"use client";

import type { FC, Ref } from "react";
import {
  WinningBidCardContent,
  type WinningBidCardContentProps,
} from "@huub-web/shared";
import { type UIAction, useActions } from "@huub-web/ui";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components/TemplatesParser";
import { useTemplates } from "../../hooks/useTemplates";

export interface WinningBidContentTemplateProps {
  realisticBid?: WinningBidCardContentProps["realisticBid"];
  realisticBidPercentage?: WinningBidCardContentProps["realisticBidPercentage"];
  winningBid?: WinningBidCardContentProps["winningBid"];
  winningBidPercentage?: WinningBidCardContentProps["winningBidPercentage"];
  bidCTA?: WinningBidCardContentProps["bidCTA"];
  description?: WinningBidCardContentProps["description"];
  templates?: TemplateCollection;
  winningBidAction?: UIAction;
}

/**
 * A template for displaying winning bid content.
 * @deprecated
 */
export const WinningBidContentTemplate: FC<
  WinningBidContentTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, winningBidAction, winningBid, ref, ...props }) => {
  const { lockUI } = useTemplates();
  const { handleAction } = useActions();

  const handleCTAClick = () => {
    if (winningBidAction) {
      handleAction(winningBidAction);
    }
  };

  return (
    <WinningBidCardContent
      ref={ref}
      disabled={lockUI}
      onWinningBidCTAClick={winningBidAction ? handleCTAClick : undefined}
      winningBid={winningBidAction ? null : winningBid}
      {...props}
    >
      {templates && templates.length > 0 && (
        <TemplatesParser templates={templates} level={1} />
      )}
    </WinningBidCardContent>
  );
};
